<footer>
  <div class="footer-container">
    <div>Data updated on {{lastUpdated}}</div>
    <br>
    <p>
      As a participant in the Amazon Associate program,
      we earn from qualifying purchases. The product prices
      and availability listed here reflect the data at the
      time shown and are subject to change. The final price
      and availability information displayed on Amazon at
      the moment of your purchase will govern the sale.
    </p>

    <br>
    <div>
      This site displays select content that originates from
      Amazon Services LLC. Said content is provided on an
      'as is' basis and is subject to change or deletion at any time.
    </div>

    <br>
    <div>
      All other site content © Bright Start Creations, LLC. All rights reserved.

    </div>
  </div>
</footer>
